import React from 'react';
import { Instagram } from '@styled-icons/boxicons-logos/Instagram';
import { Whatsapp } from '@styled-icons/boxicons-logos/Whatsapp';
import { FacebookBox } from '@styled-icons/remix-line/FacebookBox';
import { SocialBlogger } from '@styled-icons/foundation/SocialBlogger';

const WDentalUrl = process.env.GATSBY_W_DENTAL

export const socialLinks = [
  {ariaLabel: 'Acessar o Instagram da W.Dental', icon: <Instagram style={{ height: '40px', width: '40px' }} />, url: 'https://www.instagram.com/w.dental_br/'},
  {ariaLabel: 'Acessar o Facebook da W.Dental', icon: <FacebookBox style={{ height: '40px', width: '40px' }} />, url: 'https://www.facebook.com/W.Dental.br/'},
  {ariaLabel: 'Ver postagens do blog da W.Dental', icon: <SocialBlogger style={{ height: '40px', width: '40px' }} />, url: 'https://saude.w.dental'},
  {ariaLabel: 'Contato via WhatsApp da W.Dental', icon: <Whatsapp style={{ height: '40px', width: '40px' }} />, url: 'https://wa.me/5521970646570'},
]

export const pageLinks = [
  { route: `${WDentalUrl}/sobre-nos/`, title: 'Sobre Nós' },
  { route: `${WDentalUrl}/rede-credenciada/`, title: 'Rede Credenciada' },
  { route: `${WDentalUrl}/faq/`, title: 'FAQ' },
  { route: `${WDentalUrl}/contato/`, title: 'Contato' },
  { route: `https://saude.w.dental`, title: 'Blog' },
];

export const listLogin = [
  { link: 'https://portal.bdconnect.com.br/portal/?op=7&p=6#!/primeiroacesso', title: 'Primeiro Acesso' },
  { link: 'https://portal.bdconnect.com.br/portal/?op=7&p=6#!/login/', title: 'Beneficiário' },
  { link: 'https://portal.bdconnect.com.br/portal/?op=7&p=2#!/login', title: 'Empresa/RH' },
  { link: 'https://portal.bdconnect.com.br/portal/?op=7&p=3#!/login', title: 'Corretora' },
  { link: 'https://portal.bdconnect.com.br/portal/?op=7&p=3#!/login', title: 'Credenciado' },
  { link: 'https://portal.bdconnect.com.br/bdconnect/?op=7#!/esqueciminhasenha', title: 'Esqueci minha senha' },
];
